import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'harappa-ipj-angular';
  
  constructor(private titleService: Title) { }

  ngOnInit() {
    let title = localStorage.getItem('programTitle');
    if(title) {
      this.titleService.setTitle(title);
    }
  }
}
